export const LINK_WORKSHOP_TEMPLATES = 'templates';
export const LINK_WORKSHOP_MODULES = 'modules';
